// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__21tzU","title":"Header_title__2VrC5","side":"Header_side__1WMd8"};